import { createMuiTheme } from 'material-ui/styles';

export const theme = createMuiTheme({
  palette: {
    primary: {
      // light: will be calculated from palette.primary.main,
      main: '#F87733',
      contrastText: 'white',
      // dark: will be calculated from palette.primary.main,
      // contrastText: will be calculated to contrast with palette.primary.main
    },
  },
  typography: {
    fontFamily:
      '"Inter-Regular", "Avenir", "Roboto", "Helvetica", "Arial", sans-serif',
  },
  overrides: {
    MuiTypography: {
      // Name of the component ⚛️ / style sheet
      headline: {
        // Name of the rule
        color: 'black', // Some CSS
        fontSize: '1rem',
      },
      title: {
        // Name of the rule
        color: 'black', // Some CSS
        fontSize: '1rem',
      },
    },
    MuiSlider: {
      root: {
        color: '#F87733',
      },
    },
  },
});



// WEBPACK FOOTER //
// ./src/theme.js